import { Injectable } from '@angular/core';
import { EnvironmentTypes } from '../models/environment-types.enum';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    get environment(): EnvironmentTypes {
        const url = window.location.href;

        if(url.includes('/capdev')){
            return EnvironmentTypes.DEV;
        }else if (url.includes('/captst')){
            return EnvironmentTypes.TST;
        }else if (url.includes('/elssuat') || url.includes('/capuat')){
            return EnvironmentTypes.UAT;
        }else if (url.includes('/capsup')){
            return EnvironmentTypes.SUP;
        }else if(url.includes('/localhost')){
            return EnvironmentTypes.LOCAL;
        }else{
            return EnvironmentTypes.PROD;
        }
    }

    constructor() {
        // THIS IS INTENTIONAL
    }
}
